import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../../lib/colors';

export const pageStyles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'sans',
    backgroundColor: 'white',
  },
  title: {
    fontSize: 16,
    color: colors.neutral[150],
    fontFamily: 'serif',
    fontWeight: 400,
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 500,
    color: colors.neutral[150],
    marginVertical: 12,
  },
  instructions: {
    fontSize: 10,
    marginBottom: 4,
    color: colors.neutral[125],
    fontFamily: 'sans',
    fontWeight: 400,
    lineHeight: 1.4,
  },
  questionFrame: {
    fontSize: 10,
    marginBottom: 8,
    color: colors.neutral[125],
    fontFamily: 'sans',
    fontWeight: 400,
    lineHeight: 1.4,
  },
});

export const questionCardStyles = StyleSheet.create({
  card: {
    marginBottom: 10,
    borderColor: colors.neutral[75],
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
  },
  questionHeader: {
    borderBottomWidth: 1,
    borderBottomColor: colors.neutral[50],
    borderBottomStyle: 'solid',
    width: '100%',
    paddingBottom: 4,
    marginBottom: 8,
  },
  questionText: {
    fontSize: 11,
    color: colors.neutral[150],
    fontWeight: 400,
    lineHeight: 1.3,
  },
  requiredAsterisk: {
    color: colors.red[100],
    fontWeight: 700,
  },
  statementText: {
    fontSize: 11,
    color: colors.neutral[150],
    fontWeight: 400,
    marginBottom: 8,
    lineHeight: 1.3,
  },
});

export const blankFieldStyles = StyleSheet.create({
  line: {
    borderBottomWidth: 1,
    borderBottomColor: colors.neutral[100],
    borderBottomStyle: 'solid',
    height: 16,
    marginTop: 4,
  },
  ruledLinesContainer: {
    marginTop: 4,
    gap: 10,
  },
  optionsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  optionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '48%',
    marginBottom: 4,
  },
  optionRadioMarker: {
    width: 9,
    height: 9,
    borderRadius: 4.5,
    borderWidth: 1,
    borderColor: colors.neutral[150],
    marginRight: 6,
    marginTop: 1,
  },
  optionCheckboxMarker: {
    width: 9,
    height: 9,
    borderWidth: 1,
    borderColor: colors.neutral[150],
    marginRight: 6,
    marginTop: 1,
  },
  optionText: {
    fontSize: 9,
    color: colors.neutral[150],
    flex: 1,
    lineHeight: 1.2,
  },
  signatureBlock: {
    marginTop: 4,
    marginBottom: 4,
  },
  signatureLabel: {
    fontSize: 9,
    color: colors.neutral[125],
    marginBottom: 4,
  },
  signatureMetaRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginTop: 6,
  },
  signatureMetaLabel: {
    fontSize: 9,
    color: colors.neutral[125],
    width: 72,
  },
  datePlaceholder: {
    fontSize: 10,
    color: colors.neutral[150],
    marginLeft: 4,
  },
  fieldHint: {
    fontSize: 9,
    color: colors.neutral[125],
    marginBottom: 2,
  },
  followUpLabel: {
    fontSize: 9,
    color: colors.neutral[125],
    fontStyle: 'italic',
  },
  followUpRow: {
    marginTop: 8,
    marginBottom: 4,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  contactFields: {
    marginTop: 2,
  },
  unsupportedNote: {
    fontSize: 9,
    color: colors.neutral[125],
    fontStyle: 'italic',
  },
});
